import React from 'react';
import AppHeader from './AppHeader';
import {Col, Layout, Row} from 'antd';
import './styles/AppHeader.less';
import AppContent from './AppContent';

const { Header, Footer, Content } = Layout;


class AppLayout extends React.Component {
  render() {
    return (
      <Layout>
        <Header className="app-header">
          <AppHeader />
        </Header>
        <Content className="app-content">
          <Row>
            <Col
              xs={{span: 22, offset: 1}} sm={{span: 22, offset: 1}}
              md={{span: 18, offset: 3}} lg={{span: 12, offset: 6}}
              xxl={{span: 10, offset: 7}}
            >
              <AppContent/>
            </Col>
          </Row>
        </Content>
        <Footer>Footer</Footer>
      </Layout>
    )
  }
}

export default AppLayout;